const postsActionTypes = {
  FETCH_POSTS_LIST: 'FETCH_POSTS_LIST',
  FETCH_POSTS_LIST_SUCCESS: 'FETCH_POSTS_LIST_SUCCESS',
  FETCH_POSTS_LIST_FAIL: 'FETCH_POSTS_LIST_FAIL',

  FETCH_ADD_OR_EDIT_POST_SUBMISSION: 'FETCH_ADD_OR_EDIT_POST_SUBMISSION',
  FETCH_ADD_OR_EDIT_POST_SUBMISSION_SUCCESS: 'FETCH_ADD_OR_EDIT_POST_SUBMISSION_SUCCESS',
  FETCH_ADD_OR_EDIT_POST_SUBMISSION_FAIL: 'FETCH_ADD_OR_EDIT_POST_SUBMISSION_FAIL',

  FETCH_DELETE_POST_SUBMISSION: 'FETCH_DELETE_POST_SUBMISSION',
  FETCH_DELETE_POST_SUBMISSION_SUCCESS: 'FETCH_DELETE_POST_SUBMISSION_SUCCESS',
  FETCH_DELETE_POST_SUBMISSION_FAIL: 'FETCH_DELETE_POST_SUBMISSION_FAIL',

  FETCH_RSS_FEED_LIST: 'FETCH_RSS_FEED_LIST',
  FETCH_RSS_FEED_LIST_SUCCESS: 'FETCH_RSS_FEED_LIST_SUCCESS',
  FETCH_RSS_FEED_LIST_FAIL: 'FETCH_RSS_FEED_LIST_FAIL',

  FETCH_ADD_RSS_FEED_SUBMISSION: 'FETCH_ADD_RSS_FEED_SUBMISSION',
  FETCH_ADD_RSS_FEED_SUBMISSION_SUCCESS: 'FETCH_ADD_RSS_FEED_SUBMISSION_SUCCESS',
  FETCH_ADD_RSS_FEED_SUBMISSION_FAIL: 'FETCH_ADD_RSS_FEED_SUBMISSION_FAIL',

  FETCH_EDIT_RSS_FEED_SUBMISSION: 'FETCH_EDIT_RSS_FEED_SUBMISSION',
  FETCH_EDIT_RSS_FEED_SUBMISSION_SUCCESS: 'FETCH_EDIT_RSS_FEED_SUBMISSION_SUCCESS',
  FETCH_EDIT_RSS_FEED_SUBMISSION_FAIL: 'FETCH_EDIT_RSS_FEED_SUBMISSION_FAIL',
};

export default postsActionTypes;
